export default __webpack_public_path__ + "static/media/Ficha Técnica - Maracuja Organico.e049366b.pdf";